module.exports = __webpack_public_path__ + "img/check.a70ca697.svg";